import { useEffect, useRef } from "react";
import { FaHome, FaHandHoldingHeart, FaShieldAlt } from "react-icons/fa";
import { MdOutlineHandshake } from "react-icons/md";
import "../../css/elevatingExcellence.css";

const ElevatingExcellence = () => {
  const cardRefs = useRef([]);

  const items = [
    {
      icon: <FaHome size={28} color="#004d9f" />, // yellow-ish
      title: "Giải pháp hậu cần toàn diện",
      desc: "ZTO Việt Nam nổi bật trong việc cung cấp các dịch vụ hậu cần tích hợp, bao gồm vận tải hàng không và đường biển, kho bãi, phân phối, vận chuyển hàng hóa dự án và vận tải nội địa.",
    },
    {
      icon: <MdOutlineHandshake size={28} color="#004d9f" />,
      title: "Chuyên nghiệp dựa trên giá trị",
      desc: "Đề cao lòng tin và sự tôn trọng, ZTO Việt Nam duy trì mối quan hệ bền vững với khách hàng và đối tác, được đặc trưng bởi tính chuyên nghiệp, liêm chính và tuân thủ các tiêu chuẩn đạo đức cao nhất.",
    },
    {
      icon: <FaHandHoldingHeart size={28} color="#004d9f" />,
      title: "Sự xuất sắc lấy khách hàng làm trung tâm",
      desc: "Cam kết của chúng tôi là vượt qua sự kỳ vọng của khách hàng, xây dựng mối quan hệ bền vững và cung cấp dịch vụ chất lượng cao nhất quán với các tiêu chuẩn chuyên nghiệp.",
    },
    {
      icon: <FaShieldAlt size={28} color="#004d9f" />,
      title: "Độ tin cậy và Thực hành Đạo đức",
      desc: "ZTO Việt Nam nổi bật với độ tin cậy không ngừng và tuân thủ các thực hành đạo đức, đảm bảo các giải pháp logistics nhất quán và đáng tin cậy, tạo nên sự khác biệt trong ngành.",
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          } else {
            // Remove class when out of view so animation can replay on re-entry
            entry.target.classList.remove("show");
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: "0px 0px -10% 0px",
      }
    );

    cardRefs.current.forEach((card) => {
      if (card) observer.observe(card);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="elevating-section bg-cream">
      <div className="container">
        <div className="elevating-header">
          <h3 className="elevating-title">
            NÂNG TẦM SỰ XUẤT SẮC TÌM KIẾM ĐỈNH CAO CỦA GIẢI PHÁP LOGISTICS
          </h3>
          <p className="elevating-sub">
            Uy tín dựa trên các nguyên tắc đặc biệt
          </p>
        </div>

        <div className="elevating-grid">
          {items.map((it, idx) => (
            <div
              key={it.title}
              className="elevating-card"
              ref={(el) => (cardRefs.current[idx] = el)}
            >
              <div className="card-icon-wrap">
                <div className="card-icon-bg">{it.icon}</div>
              </div>
              <h3 className="card-title">{it.title}</h3>
              <p className="card-desc">{it.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default ElevatingExcellence;
